export class GdsgActiveWorkers {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "consolidation",
            "baseName": "consolidation",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "replication",
            "baseName": "replication",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgActiveWorkers.attributeTypeMap;
    }
    constructor() {
    }
}
